import { useLazyQuery, useQuery } from "@apollo/client";
import { GROUPS } from "../group.queries";
import { GroupsQuery, GroupsQueryVariables } from "../../../__generated__/GroupsQuery";

export const useGroups = (variables: GroupsQueryVariables) => {
  return useQuery<GroupsQuery, GroupsQueryVariables>(GROUPS, { variables });
};

export const useLazyGroups = () => {
  return useLazyQuery<GroupsQuery, GroupsQueryVariables>(GROUPS);
};
